import * as _ from 'lodash';
import template from './dynamarkProhibitModal.html';

class DynamarkProhibitModalController{

    /* @ngInject */
    constructor($window,
        constants,
        dataContext,
        $state,
        $rootScope,
        $scope)
    {
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        this.$window = $window;
        this.$state = $state;
        this.constants = constants;
        this.dataContext = dataContext;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
    }

    close() {
        this.$dismiss();
        this.$state.go('adc.home');
    }
}

export default {
    template: template,
    bindings: {
        config: '<'
    },
    controller: DynamarkProhibitModalController
};
